import { Injectable } from '@angular/core';
import { Produto } from 'src/app/models/product-picklist.model';

// Cache em memória do catálogo de produtos da loja, fora do ciclo de vida do
// app-product-picklist — o componente é destruído/recriado toda vez que o
// usuário troca de aba (mananger/activeOption usam *ngIf), então guardar
// esse estado DENTRO do componente faz a lista sumir e recarregar do zero a
// cada reentrada. Um service providedIn:'root' sobrevive a isso (e também é
// reaproveitado entre slicks diferentes da mesma loja).
@Injectable({ providedIn: 'root' })
export class ProductCatalogCacheService {
  private storeId: number | null = null;
  private products: Produto[] = [];
  private nextCursor: string | null = null;
  private hasNextPage = false;
  private hasShopifyIntegration = false;
  private hasNuvemshopIntegration = false;
  private loaded = false;

  hasCacheFor(storeId: number): boolean {
    return this.loaded && this.storeId === storeId;
  }

  get(storeId: number) {
    if (!this.hasCacheFor(storeId)) return null;
    return {
      products: this.products,
      nextCursor: this.nextCursor,
      hasNextPage: this.hasNextPage,
      hasShopifyIntegration: this.hasShopifyIntegration,
      hasNuvemshopIntegration: this.hasNuvemshopIntegration,
    };
  }

  set(storeId: number, data: {
    products: Produto[];
    nextCursor: string | null;
    hasNextPage: boolean;
    hasShopifyIntegration: boolean;
    hasNuvemshopIntegration: boolean;
  }): void {
    this.storeId = storeId;
    this.products = data.products;
    this.nextCursor = data.nextCursor;
    this.hasNextPage = data.hasNextPage;
    this.hasShopifyIntegration = data.hasShopifyIntegration;
    this.hasNuvemshopIntegration = data.hasNuvemshopIntegration;
    this.loaded = true;
  }

  appendProducts(storeId: number, newProducts: Produto[], nextCursor: string | null, hasNextPage: boolean): void {
    if (this.storeId !== storeId) return;
    this.products = [...this.products, ...newProducts];
    this.nextCursor = nextCursor;
    this.hasNextPage = hasNextPage;
  }

  invalidate(): void {
    this.loaded = false;
    this.products = [];
    this.storeId = null;
  }
}
